import React, { Component } from "react";
import {
  Alert,
  Image,
  Linking,
  PermissionsAndroid,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  SafeAreaView
} from "react-native";
import AsyncStorage from '@react-native-community/async-storage';
import InAppBrowser from "react-native-inappbrowser-reborn";
import QiscusSDK from "qiscus-sdk-core";
import ImagePicker from "react-native-image-picker";

import { Header, PulseLoader } from "../components";
import {
  getQiscusAppId,
  getBaseUrl,
  setConsultation
} from "../helpers/storage";
import {
  Menu,
  MenuOption,
  MenuOptions,
  MenuProvider,
  MenuTrigger
} from "react-native-popup-menu";
import Modal from "react-native-modal";
import { Bubble, GiftedChat, Message } from "react-native-gifted-chat";
import _ from "lodash";
import { connect } from "react-redux";
import staticColors from "../constants/staticColors";
import AutoHeightImage from "react-native-auto-height-image";
import fonts from "../constants/fonts";
import { Room } from "qiscus-sdk-core/lib/lib/Room";

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  content: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    padding: 30
  },
  message: {
    color: "#FFF",
    ...fonts.regular,
    fontSize: 20,
    padding: 40,
    paddingBottom: 10,
    textAlign: "center"
  }
});

class WaitingScreen extends Component {
  constructor(props) {
    super(props);

    this.messageIds = new Set();
    this.messages = [];

    this.state = {
      agentAvatar: "",
      doctor: null,
      room: null,
      temporaryRoom: null,
      isModalVisible: false,
      agent: null,
      messages: [],
      time: 0
    };
  }

  _handlePress = () => {
    this.clearRoom(this.state.temporaryRoom);
  };

  async createRoom() {
    this.qiscus = new QiscusSDK();
    this.qiscus.debugMode = false;
    this.qiscus.debugMQTTMode = false;
    this.qiscus.init({
      AppId: getQiscusAppId(),

      options: {
        loginSuccessCallback: data => { },
        commentDeletedCallback: data => {
          data.commentUniqueIds.forEach(commentUniqueId => {
            const message = this.messages.find(
              message => message.tempId === commentUniqueId
            );

            const indexToDelete = this.messages.indexOf(message);

            if (indexToDelete > -1) {
              this.messages = this.messages
                .slice(0, indexToDelete)
                .concat(this.messages.slice(indexToDelete + 1));

              this.setState({
                messages: this.messages
              });
            }
          });
        },
        newMessagesCallback: data =>
          data.forEach(comment => {
            if (this.messageIds.has(comment.id)) {
              return;
            }

            this.messageIds.add(comment.id);

            let message;
            let image = null;
            let file = null;
            let filename = null;
            let card = null;
            let replyTo = null;

            let system =
              comment.payload && comment.payload["type"] === "custom";

            if (comment.type === "file_attachment") {
              const extensions = ["jpg", "jpeg", "png"];

              if (
                extensions.includes(
                  comment.payload.url
                    .split(".")
                    .pop()
                    .toLowerCase()
                )
              ) {
                image = comment.payload.url;
                filename = comment.payload.file_name;
                message = comment.payload.caption;
              } else {
                file = comment.payload.url;
                filename = comment.payload.file_name;
              }
            } else {
              message = comment.message;
            }

            if (comment.type === "card") {
              card = comment.payload;
              message = "";
            } else if (comment.type === "reply") {
              let repliedMessage = comment.payload.replied_comment_message;
              let repliedPreview = null;

              if (comment.payload.replied_comment_type === "file_attachment") {
                const extensions = ["jpg", "jpeg", "png"];

                if (
                  extensions.includes(
                    comment.payload.replied_comment_payload.url
                      .split(".")
                      .pop()
                      .toLowerCase()
                  )
                ) {
                  repliedMessage = "";
                  repliedPreview = {
                    uri: comment.payload.replied_comment_payload.url
                  };
                } else {
                  repliedMessage = "";
                  repliedPreview = require("../assets/attachment.png");
                }
              }

              replyTo = {
                message: repliedMessage,
                preview: repliedPreview,
                user: {
                  name: comment.payload.replied_comment_sender_username
                }
              };
            }

            const c = {
              _id: comment.id,
              tempId: comment.unique_temp_id,
              text: message,
              createdAt: comment["timestamp"],
              user: {
                _id:
                  this.qiscus.userData.id === comment["user_id"]
                    ? this.qiscus.userData.email
                    : comment["user_id"],
                name: comment["username"],
                avatar: comment["user_avatar_url"]
              },
              image,
              file,
              filename,
              system,
              card,
              replyTo
            };

            this.messages = GiftedChat.append(this.messages, c).sort(
              (a, b) => b._id - a._id
            );

            this.setState(() => ({
              messages: this.messages
            }));
          })
      }
    });

    let responseData = null;

    let time = 0;

    this.interval = setInterval(() => {
      this.setState({
        time: time * 3
      });

      if (++time >= 20) {
        if (this.state.room === null) {
          this.clearRoom(responseData);
        }
      }

      if (responseData) {
        this.checkRoom(responseData);
      }
    }, 3000);

    if (this.props.navigation.state.params.activeConsultation) {
      responseData = this.props.navigation.state.params.activeConsultation;
    } else {
      const token = this.props.token;
      const fcmToken = this.props.fcmToken;

      let requestBody;

      if (this.props.navigation.state.params.dependent) {
        requestBody = JSON.stringify({
          // card_number_dependency: this.props.navigation.state.params
          //   .policyNumber,
          dependent: this.props.navigation.state.params.dependent,
          symptoms: {
            complaint_id: this.props.navigation.state.params.complaintIds,
            consultation: this.props.navigation.state.params.consultation,
            duration: this.props.navigation.state.params.duration,
            duration_unit: this.props.navigation.state.params.durationUnit
          },
          device_token: fcmToken,
          device_platform: Platform.OS
        });
      } else {
        requestBody = JSON.stringify({
          symptoms: {
            complaint_id: this.props.navigation.state.params.complaintIds,
            consultation: this.props.navigation.state.params.consultation,
            duration: this.props.navigation.state.params.duration,
            duration_unit: this.props.navigation.state.params.durationUnit
          },
          device_token: fcmToken,
          device_platform: Platform.OS
        });
      }

      const response = await fetch(getBaseUrl() + "consultations/start", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        method: "POST",
        body: requestBody
      });

      const json = await response.json();

      responseData = json["data"];
    }

    this.setState({
      temporaryRoom: responseData
    });

    await this.qiscus.setUser(responseData["email"], responseData["password"]);

    if (this.props.navigation.state.params.activeConsultation) {
    } else {
      await this.qiscus.sendComment(
        responseData["room_id"],
        this.props.navigation.state.params.consultation,
        null,
        "text",
        null,
        null
      );
    }
  }

  async clearRoom(roomData) {
    if (roomData) {
      const token = this.props.token;

      await fetch(getBaseUrl() + "consultations/cancel", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify({
          trx_id: roomData["trx_id"]
        })
      });

      Alert.alert(
        "Timeout",
        "Tidak ada dokter yang tersedia, silakan coba beberapa saat lagi."
      );
    }

    this.props.navigation.goBack();
  }

  checkRoom(roomData) {
    if (!this.qiscus.roomAdapter) {
      return;
    }

    this.qiscus.roomAdapter.getRoomById(roomData["room_id"]).then(async (response) => {
      const qRoomData = response.results.room;
      qRoomData.name = roomData.room_name;
      qRoomData.comments = response.results.comments.reverse();

      const qRoom = new Room(qRoomData);

      const options = JSON.parse(qRoom.options);

      if (options.is_resolved) {
        this.markDone();

        return;
      }

      if (this.messages.length === 0) {
        const comments = qRoom.comments.filter(comment => {
          const common = this.messageIds.has(comment.id);

          if (common) {
            return false;
          }

          this.messageIds.add(comment.id);

          return true;
        });

        const messages = _.map(comments, comment => {
          let message;
          let image = null;
          let file = null;
          let filename = null;
          let card = null;
          let replyTo = null;

          let system = comment.payload && comment.payload["type"] === "custom";

          if (comment.type === "file_attachment") {
            const extensions = ["jpg", "jpeg", "png"];

            if (
              extensions.includes(
                comment.payload.url
                  .split(".")
                  .pop()
                  .toLowerCase()
              )
            ) {
              image = comment.payload.url;
              filename = comment.payload.file_name;
              message = comment.payload.caption;
            } else {
              file = comment.payload.url;
              filename = comment.payload.file_name;
            }
          } else {
            message = comment.message;
          }

          if (comment.type === "card") {
            card = comment.payload;
            message = "";
          } else if (comment.type === "reply") {
            let repliedMessage = comment.payload.replied_comment_message;
            let repliedPreview = null;

            if (comment.payload.replied_comment_type === "file_attachment") {
              const extensions = ["jpg", "jpeg", "png"];

              if (
                extensions.includes(
                  comment.payload.replied_comment_payload.url
                    .split(".")
                    .pop()
                    .toLowerCase()
                )
              ) {
                repliedMessage = "";
                repliedPreview = {
                  uri: comment.payload.replied_comment_payload.url
                };
              } else {
                repliedMessage = "";
                repliedPreview = require("../assets/attachment.png");
              }
            }

            replyTo = {
              message: repliedMessage,
              preview: repliedPreview,
              user: {
                name: comment.payload.replied_comment_sender_username
              }
            };
          }

          return {
            _id: comment.id,
            tempId: comment.unique_id,
            text: message,
            createdAt: comment.timestamp,
            user: {
              _id: comment["username_real"],
              name: comment["username_as"],
              avatar: comment["avatar"]
            },
            image,
            file,
            filename,
            system,
            card,
            replyTo
          };
        });

        this.messages = GiftedChat.append(
          this.messages,
          _.reverse(messages)
        ).sort((a, b) => b._id - a._id);

        this.setState(() => ({
          messages: this.messages
        }));
      }

      const agents = _.filter(
        qRoom.participants,
        item => item.extras && item.extras.type === "agent"
      );

      let agent;

      // in the case there are more than 1 agent, remove agent containing "prixa"
      if (agents.length > 1) {
        const filteredAgent = _.filter(
          agents,
          item => item.username ?
            String(item.username).toLowerCase().indexOf('prixa') < 0 : false
        );
        agent = _.head(filteredAgent);
      } else {
        agent = _.find(
          qRoom.participants,
          item => item.extras && item.extras.type === "agent"
        );
      }

      // store active consultation on local storage, along with avatar and username
      await AsyncStorage.setItem('active_consultation', JSON.stringify({
        ...roomData,
        avatar_url: agent["avatar_url"],
        username: agent["username"]
      })
      )

      if (agent) {
        if (this.state.agent === null || this.state.agent.id !== agent.id) {
          this.setState(prev => {
            const token = this.props.token;

            fetch(getBaseUrl() + "consultations/set-agent", {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json"
              },
              method: "POST",
              body: JSON.stringify({
                trx_id: roomData["trx_id"]
              })
            })
              .then(res => res.json())
              .then(json => {
                setConsultation(roomData);

                if (json["data"]["pre_assessment"] === null) {
                  this.props.navigation.navigate("PreAssessment", {
                    doctor: {
                      avatarUrl: json["data"]["doctor"]["doctor_photo"],
                      fullName:
                        json["data"]["doctor"]["doctor_f_name"] +
                        " " +
                        json["data"]["doctor"]["doctor_l_name"]
                    }
                  });
                }
              });

            return {
              agent: agent,
              agentAvatar: agent["avatar_url"],
              room: roomData,
              temporaryRoom: null
            };
          });
        }
      }
    });
  }

  componentDidMount() {
    this.promise = this.createRoom();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  async markDone() {
    this.setState({
      isModalVisible: false
    });

    const token = this.props.token;

    await fetch(getBaseUrl() + "consultations/finish", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "POST",
      body: JSON.stringify({
        trx_id: this.state.room["trx_id"]
      })
    });

    setConsultation(null);

    if (this.state.room && this.state.agent) {
      this.props.navigation.replace("Rating", {
        transactionId: this.state.room["trx_id"],
        agentAvatar: this.state.agent["avatar_url"],
        agentName: this.state.agent["username"],
        agentSpecialities: this.state.agent["email"]
      });
    } else {
      this.props.navigation.goBack();
    }
  }

  navigateCall = (callType) => {
    const { navigation } = this.props
    const { agent, room } = this.state
    navigation.navigate(callType, {
      doctor: {
        fullName: agent["username"]
      },
      patient: {
        id: navigation.state.params.patientId
      },
      transaction: {
        id: room["trx_id"]
      }
    });
  }

  goToAudioCallScreen = () => {
    this.navigateCall("AudioCall");
  }

  goToVideoCallScreen = () => {
    this.navigateCall("VideoCall");
  }

  render() {
    let avatar;

    if (this.state.doctor) {
      avatar = require("../assets/doctor.jpg");
    } else {
      avatar = require("../assets/avatars/doctor.png");
    }

    const foreground = (
      <View
        style={[
          styles.container,
          { backgroundColor: this.props.themeColors.primary }
        ]}
      >
        {this.state.time >= 10 && (
          <Header
            onPress={this._handlePress}
            position="start"
            text="Batal"
            theme="light"
          />
        )}
        <View style={styles.content}>
          <Text style={styles.message}>
            Tunggu Sebentar ya, Kami sedang mencarikan Dokter untuk Anda
          </Text>
          <PulseLoader avatar={avatar} />
        </View>
      </View>
    );

    if (this.state.room) {
      return (
        <MenuProvider>
          <View
            style={{
              backgroundColor: this.props.themeColors.primary,
              flex: 1
            }}
          >
            <Modal
              isVisible={this.state.isModalVisible}
              backdropColor="#515151"
              useNativeDriver={true}
            >
              <View
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: 40,
                  padding: 30
                }}
              >
                <Text
                  style={{
                    color: "#808080",
                    fontSize: 20,
                    ...fonts.bold,
                    textAlign: "center",
                    marginBottom: 60
                  }}
                >
                  Anda yakin akan mengakhiri sesi percakapan?
                </Text>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between"
                  }}
                >
                  <TouchableOpacity
                    onPress={() => {
                      this.markDone();
                    }}
                  >
                    <View
                      style={{
                        backgroundColor: "#E64F4F",
                        borderRadius: 20,
                        paddingVertical: 10,
                        paddingHorizontal: 35
                      }}
                    >
                      <Text
                        style={{
                          color: "#FFFFFF",
                          fontSize: 16,
                          ...fonts.bold
                        }}
                      >
                        Akhiri
                      </Text>
                    </View>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => {
                      this.setState({
                        isModalVisible: false
                      });
                    }}
                  >
                    <View
                      style={{
                        backgroundColor: "#5DBE66",
                        borderRadius: 20,
                        paddingVertical: 10,
                        paddingHorizontal: 35
                      }}
                    >
                      <Text
                        style={{
                          color: "#FFFFFF",
                          fontSize: 16,
                          ...fonts.bold
                        }}
                      >
                        Lanjutkan
                      </Text>
                    </View>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>
            <SafeAreaView
              style={{
                marginHorizontal: 15,
                marginVertical: 10,
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  this.props.navigation.navigate("DoctorProfile", {
                    transactionId: this.state.room["trx_id"],
                    patientId: this.props.navigation.state.params.patientId,
                    doctorFullname: this.state.agent["username"]
                  });
                }}
                style={{ flexGrow: 1 }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    flexGrow: 1
                  }}
                >
                  <Image
                    source={
                      this.state.agent
                        ? {
                          uri:
                            this.state.agentAvatar ||
                            "https://izi.medlinx.id/uploads/userfiles/test.png"
                        }
                        : require("../assets/avatars/doctor.png")
                    }
                    style={{
                      margin: 10,
                      height: 45,
                      width: 45,
                      borderRadius: 23
                    }}
                  />
                  <Text
                    style={{
                      color: "#FFFFFF",
                      fontSize: 17,
                      ...fonts.regular
                    }}
                  >
                    {this.state.agent ? this.state.agent.username : "-"}
                  </Text>
                </View>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  this.setState({
                    isModalVisible: true
                  });
                }}
              >
                <Text
                  style={{
                    color: staticColors.white,
                    ...fonts.bold,
                    fontSize: 16,
                    paddingVertical: 4,
                    paddingHorizontal: 12
                  }}
                >
                  END
                </Text>
              </TouchableOpacity>
              <Menu>
                <MenuTrigger>
                  <Image
                    source={require("../assets/round_more_vert_white_18dp.png")}
                    style={{ height: 25, width: 25 }}
                  />
                </MenuTrigger>
                <MenuOptions>
                  <MenuOption
                    customStyles={{
                      optionText: {
                        color: "#808080",
                        ...fonts.regular
                      },
                      optionWrapper: {
                        paddingHorizontal: 25,
                        paddingVertical: 15
                      }
                    }}
                    onSelect={() => {
                      if (Platform.OS === "android") {
                        let permissions = [
                          PermissionsAndroid.PERMISSIONS.RECORD_AUDIO
                        ];

                        PermissionsAndroid.requestMultiple(permissions).then(
                          granted => {
                            const recordAudioGranted =
                              granted["android.permission.RECORD_AUDIO"] ===
                              "granted";

                            if (recordAudioGranted) {
                              this.goToAudioCallScreen()
                            }
                          }
                        );
                      } else {
                        this.goToAudioCallScreen()
                      }
                    }}
                    text="Audio Call"
                  />
                  <MenuOption
                    customStyles={{
                      optionText: {
                        color: "#808080",
                        ...fonts.regular
                      },
                      optionWrapper: {
                        paddingHorizontal: 25,
                        paddingVertical: 15
                      }
                    }}
                    onSelect={() => {
                      if (Platform.OS === "android") {
                        let permissions = [
                          PermissionsAndroid.PERMISSIONS.CAMERA,
                          PermissionsAndroid.PERMISSIONS.RECORD_AUDIO
                        ];

                        PermissionsAndroid.requestMultiple(permissions).then(
                          granted => {
                            const cameraGranted =
                              granted["android.permission.CAMERA"] ===
                              "granted";
                            const recordAudioGranted =
                              granted["android.permission.RECORD_AUDIO"] ===
                              "granted";

                            if (cameraGranted && recordAudioGranted) {
                              this.goToVideoCallScreen()
                            }
                          }
                        );
                      } else {
                        this.goToVideoCallScreen()
                      }
                    }}
                    text="Video Call"
                  />
                </MenuOptions>
              </Menu>
            </SafeAreaView>
            <View
              style={{
                backgroundColor: this.props.themeColors.lightestPrimary,
                flex: 1,
                borderTopStartRadius: 40,
                borderTopEndRadius: 40,
                paddingTop: 40
              }}
            >
              <GiftedChat
                renderActions={() => {
                  return (
                    <TouchableOpacity
                      onPress={() => {
                        ImagePicker.showImagePicker(
                          {
                            title: "Pilih Gambar",
                            maxHeight: 1024,
                            maxWidth: 1024,
                            quality: 0.6
                          },
                          response => {
                            if (response.didCancel) {
                            } else if (response.error) {
                            } else if (response.customButton) {
                            } else {
                              this.qiscus.upload(
                                {
                                  uri: response.uri,
                                  type: response.type,
                                  name:
                                    response.fileName ||
                                    response.uri.split("/").pop()
                                },
                                (error, progress, url) => {
                                  if (url) {
                                    const filePayload = JSON.stringify({
                                      url: url,
                                      caption: "-"
                                    });

                                    this.qiscus
                                      .sendComment(
                                        this.state.room["room_id"],
                                        "-",
                                        null,
                                        "file_attachment",
                                        filePayload,
                                        null
                                      )
                                      .catch(() => {
                                        Alert.alert(
                                          "Whoops",
                                          "File tidak terkirim."
                                        );
                                      });
                                  }
                                }
                              );
                            }
                          }
                        );
                      }}
                      style={{ padding: 8, alignSelf: "center" }}
                    >
                      <Image
                        source={require("../assets/icons/baseline_panorama_black_18dp.png")}
                      />
                    </TouchableOpacity>
                  );
                }}
                renderMessage={props => {
                  if (props.currentMessage.card) {
                    return (
                      <Message
                        {...props}
                        renderBubble={props => {
                          return (
                            <Bubble
                              {...props}
                              renderCustomView={props => {
                                return (
                                  <View
                                    style={{
                                      borderRadius: 13,
                                      width: 200,
                                      marginBottom: 8
                                    }}
                                  >
                                    <AutoHeightImage
                                      width={200}
                                      source={{
                                        uri: props.currentMessage.card.image
                                      }}
                                    />
                                    <Text
                                      style={{
                                        padding: 8,
                                        fontSize: 12,
                                        ...fonts.bold
                                      }}
                                    >
                                      {props.currentMessage.card.title}
                                    </Text>
                                    <Text
                                      style={{
                                        padding: 8,
                                        fontSize: 12,
                                        ...fonts.regular
                                      }}
                                    >
                                      {props.currentMessage.card.description}
                                    </Text>
                                    {props.currentMessage.card.buttons.map(
                                      (payload, index) => {
                                        return (
                                          <TouchableOpacity
                                            key={index}
                                            onPress={() => {
                                              InAppBrowser.isAvailable().then(
                                                available => {
                                                  if (available) {
                                                    InAppBrowser.open(
                                                      payload.payload.url
                                                    );
                                                  } else {
                                                    Linking.canOpenURL(
                                                      payload.payload.url
                                                    ).then(supported => {
                                                      if (supported) {
                                                        return Linking.openURL(
                                                          payload.payload.url
                                                        );
                                                      }
                                                    });
                                                  }
                                                }
                                              );
                                            }}
                                            style={{
                                              borderTopWidth: 1,
                                              borderBottomWidth: 1,
                                              borderColor: "#ddd",
                                              alignItems: "center"
                                            }}
                                          >
                                            <Text
                                              style={{
                                                padding: 8,
                                                ...fonts.regular,
                                                color: "#515151"
                                              }}
                                            >
                                              {payload.label}
                                            </Text>
                                          </TouchableOpacity>
                                        );
                                      }
                                    )}
                                  </View>
                                );
                              }}
                              wrapperStyle={{
                                left: {
                                  backgroundColor: staticColors.white,
                                  marginVertical: 3
                                }
                              }}
                            />
                          );
                        }}
                      />
                    );
                  }

                  if (props.currentMessage.file) {
                    return (
                      <Message
                        {...props}
                        renderBubble={props => {
                          return (
                            <Bubble
                              {...props}
                              renderCustomView={props => {
                                return (
                                  <TouchableOpacity
                                    onPress={() => {
                                      InAppBrowser.isAvailable().then(
                                        available => {
                                          if (available) {
                                            InAppBrowser.open(
                                              props.currentMessage.file
                                            );
                                          } else {
                                            Linking.canOpenURL(
                                              props.currentMessage.file
                                            ).then(supported => {
                                              if (supported) {
                                                return Linking.openURL(
                                                  props.currentMessage.file
                                                );
                                              }
                                            });
                                          }
                                        }
                                      );
                                    }}
                                    style={{
                                      padding: 10
                                    }}
                                  >
                                    <View>
                                      <Image
                                        source={require("../assets/attachment.png")}
                                        style={{
                                          height: 80,
                                          width: 80
                                        }}
                                      />
                                      <Text style={{ marginTop: 10 }}>
                                        {props.currentMessage.filename ||
                                          props.currentMessage.file
                                            .split("/")
                                            .pop()}
                                      </Text>
                                    </View>
                                  </TouchableOpacity>
                                );
                              }}
                              wrapperStyle={{
                                left: {
                                  backgroundColor: staticColors.white
                                },
                                right: {
                                  backgroundColor: this.props.themeColors
                                    .primary
                                }
                              }}
                            />
                          );
                        }}
                      />
                    );
                  }

                  if (props.currentMessage.replyTo) {
                    return (
                      <Message
                        {...props}
                        renderBubble={props => {
                          return (
                            <Bubble
                              {...props}
                              renderCustomView={props => {
                                if (props.currentMessage.replyTo.preview) {
                                  return (
                                    <View
                                      style={{
                                        borderTopStartRadius: 15,
                                        borderTopEndRadius: 15,
                                        margin: 4,
                                        borderStartColor: this.props.themeColors
                                          .primary,
                                        borderStartWidth: 2,
                                        backgroundColor: "rgba(0, 0, 0, .01)",
                                        flexDirection: "row",
                                        alignItems: "center"
                                      }}
                                    >
                                      <Text
                                        style={{
                                          padding: 8,
                                          color: this.props.themeColors.primary
                                        }}
                                      >
                                        {props.currentMessage.replyTo.user.name}
                                      </Text>
                                      <Image
                                        source={
                                          props.currentMessage.replyTo.preview
                                        }
                                        style={{
                                          marginHorizontal: 10,
                                          width: 30,
                                          height: 30
                                        }}
                                      />
                                    </View>
                                  );
                                } else {
                                  return (
                                    <View
                                      style={{
                                        borderTopStartRadius: 15,
                                        borderTopEndRadius: 15,
                                        margin: 4,
                                        padding: 8,
                                        borderStartColor: this.props.themeColors
                                          .primary,
                                        borderStartWidth: 2,
                                        backgroundColor: "rgba(0, 0, 0, .01)"
                                      }}
                                    >
                                      <Text
                                        style={{
                                          color: this.props.themeColors.primary
                                        }}
                                      >
                                        {props.currentMessage.replyTo.user.name}
                                      </Text>
                                      <Text>
                                        {props.currentMessage.replyTo.message}
                                      </Text>
                                    </View>
                                  );
                                }
                              }}
                              wrapperStyle={{
                                left: {
                                  backgroundColor: staticColors.white
                                },
                                right: {
                                  backgroundColor: this.props.themeColors
                                    .primary
                                }
                              }}
                            />
                          );
                        }}
                      />
                    );
                  }

                  return <Message {...props} />;
                }}
                renderBubble={props => {
                  return (
                    <Bubble
                      {...props}
                      wrapperStyle={{
                        left: {
                          backgroundColor: staticColors.white
                        },
                        right: {
                          backgroundColor: this.props.themeColors.primary
                        }
                      }}
                    />
                  );
                }}
                messages={this.state.messages}
                onSend={messages =>
                  messages.map(item =>
                    this.qiscus
                      .sendComment(
                        this.state.room["room_id"],
                        item.text,
                        null,
                        "text",
                        null,
                        null
                      )
                      .catch(() => {
                        Alert.alert(
                          "Whoops",
                          `Pesan "${item.text}" tidak terkirim, silakan cek koneksi Anda dan coba kembali.`
                        );
                      })
                  )
                }
                user={{
                  _id: this.state.room["email"]
                }}
              />
            </View>
          </View>
        </MenuProvider>
      );
    } else {
      return foreground;
    }
  }
}

export default connect(state => ({
  fcmToken: state.fcmToken,
  themeColors: state.themeColors,
  token: state.token
}))(WaitingScreen);
